import { enableProdMode, LOCALE_ID } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import { COMPILER_OPTIONS, Injectable } from "@angular/core";
import { ResourceLoader } from "@angular/compiler";

let index = 1;
@Injectable()
export class CustomResourceLoader extends ResourceLoader {
  get(url: string): Promise<string> {
    url += `?${index++}`;
    debugger;
    let resolve: (result: any) => void;
    let reject: (error: any) => void;
    const promise = new Promise<string>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "text";

    xhr.onload = function() {
      // responseText is the old-school way of retrieving response (supported by IE8 & 9)
      // response/responseType properties were introduced in ResourceLoader Level2 spec (supported
      // by IE10)
      const response = xhr.response || xhr.responseText;

      // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
      let status = xhr.status === 1223 ? 204 : xhr.status;

      // fix status code when it is 0 (0 status is undocumented).
      // Occurs when accessing file resources or on Android 4.1 stock browser
      // while retrieving files from application cache.
      if (status === 0) {
        status = response ? 200 : 0;
      }

      if (200 <= status && status <= 300) {
        resolve(response);
      } else {
        reject(`Failed to load ${url}`);
      }
    };

    xhr.onerror = function() {
      reject(`Failed to load ${url}`);
    };

    xhr.send();
    return promise;
  }
}

console.log('CONFIG:',environment);

if (environment.production) {
  enableProdMode();
}
/* 
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err)); */

platformBrowserDynamic([
  { provide: LOCALE_ID, useValue: "fr" }
]).bootstrapModule(AppModule, {
  providers: [{ provide: LOCALE_ID, useValue: "fr" }]
});

/* platformBrowserDynamic([
  {
    provide: COMPILER_OPTIONS,
    useValue: {
      providers: [
        {
          provide: ResourceLoader,
          useClass: CustomResourceLoader,
          deps: []
        }
      ]
    },
    multi: true
  }
]).bootstrapModule(AppModule); */



// WEBPACK FOOTER //
// ./src/main.ts